// extracted by mini-css-extract-plugin
export var messageSideLeft = "_np-1";
export var stateContainer = "_np-0";